var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"round-cta",attrs:{"role":"button"}},[_c('img',{staticClass:"round-cta__icon",attrs:{"src":("/img/ui/icon-" + _vm.icon + ".svg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }